// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
// Entry imports
const actions = require('./actions')
const selectors = require('./selectors')

function mapStateToProps(state) {
  if (!selectors.isVisible(state)) {
    return { isVisible: false }
  }
  const { authModal } = state
  return {
    errorProvider: authModal.errorProvider,
    errorType: authModal.errorType,
    hasAccount: authModal.hasAccount,
    isVisible: true,
    socialProviders: selectors.providers(state)
  }
}

const mapDispatchToProps = {
  onClose: actions.hide,
  onHasAccountToggle: actions.show,
  onSocialProviderAuth: actions.socialAuth
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    require('./component-dumb')
  )
)
